import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [mode, setMode]         = useState('login'); // 'login' | 'forgot' | 'sent'
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotError, setForgotError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const { data, error: authError } = await supabase.auth.signInWithPassword({ email, password });
    if (authError) { setError('E-mail ou senha incorretos.'); setLoading(false); return; }
    const { data: profile } = await supabase.from('profiles').select('*').eq('id', data.user.id).single();
    if (!profile) { setError('Perfil não encontrado. Contate o administrador.'); setLoading(false); return; }
    onLogin(data.user, profile);
    setLoading(false);
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setForgotLoading(true); setForgotError('');
    const { error: err } = await supabase.auth.resetPasswordForEmail(forgotEmail, {
      redirectTo: 'https://gestao-arla.vercel.app/reset-password',
    });
    if (err) { setForgotError('Não foi possível enviar o e-mail. Verifique o endereço.'); setForgotLoading(false); return; }
    setMode('sent');
    setForgotLoading(false);
  };

  return (
    <div style={S.bg}>
      <div style={S.card}>
        <div style={S.logo}>
          <img src="/logo.png" alt="Plantivo" style={S.logoImg} />
          <div style={S.logoTitle}>Gestão Arla</div>
        </div>

        {/* LOGIN */}
        {mode === 'login' && (
          <form onSubmit={handleLogin} style={S.form}>
            <div style={S.field}>
              <label style={S.label}>E-mail</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="seu@email.com.br" required style={S.input} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Senha</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" required style={S.input} />
            </div>
            {error && <div style={S.error}>{error}</div>}
            <button type="submit" disabled={loading} style={S.btn}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
            <button type="button" style={S.linkBtn} onClick={() => { setMode('forgot'); setForgotEmail(email); }}>
              Esqueceu a senha?
            </button>
          </form>
        )}

        {/* ESQUECI SENHA */}
        {mode === 'forgot' && (
          <form onSubmit={handleForgot} style={S.form}>
            <p style={S.hint}>Digite seu e-mail e enviaremos um link para redefinir sua senha.</p>
            <div style={S.field}>
              <label style={S.label}>E-mail</label>
              <input type="email" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)}
                placeholder="seu@email.com.br" required style={S.input} />
            </div>
            {forgotError && <div style={S.error}>{forgotError}</div>}
            <button type="submit" disabled={forgotLoading} style={S.btn}>
              {forgotLoading ? 'Enviando...' : 'Enviar link de redefinição'}
            </button>
            <button type="button" style={S.linkBtn} onClick={() => setMode('login')}>
              ← Voltar ao login
            </button>
          </form>
        )}

        {/* E-MAIL ENVIADO */}
        {mode === 'sent' && (
          <div style={{ textAlign: 'center' }}>
            <div style={S.successIcon}>✓</div>
            <div style={S.successTitle}>E-mail enviado!</div>
            <p style={S.hint}>Verifique sua caixa de entrada em <b>{forgotEmail}</b> e clique no link para redefinir sua senha.</p>
            <button type="button" style={S.btn} onClick={() => setMode('login')}>
              Voltar ao login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const S = {
  bg: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f4f0' },
  card: { background: '#fff', borderRadius: 14, border: '0.5px solid #e0ddd6', padding: '36px 32px', width: 360, boxSizing: 'border-box' },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginBottom: 28 },
  logoImg: { width: 180, height: 'auto', objectFit: 'contain' },
  logoTitle: { fontSize: 15, fontWeight: 500, color: '#555', fontFamily: '"DM Sans", sans-serif', letterSpacing: '0.02em' },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  field: { display: 'flex', flexDirection: 'column', gap: 5 },
  label: { fontSize: 12, fontWeight: 500, color: '#555', fontFamily: '"DM Sans", sans-serif' },
  input: { border: '0.5px solid #ddd', borderRadius: 7, padding: '9px 12px', fontSize: 13, fontFamily: '"DM Sans", sans-serif', background: '#fafaf8', color: '#1a1a18', outline: 'none' },
  error: { background: '#fef2f2', border: '0.5px solid #fca5a5', borderRadius: 7, padding: '9px 12px', fontSize: 13, color: '#b91c1c', fontFamily: '"DM Sans", sans-serif' },
  btn: { background: '#1a5c38', color: '#fff', border: 'none', borderRadius: 7, padding: 11, fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', marginTop: 4 },
  linkBtn: { background: 'none', border: 'none', color: '#888', fontSize: 12, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', textDecoration: 'underline', padding: 0, marginTop: -6 },
  hint: { fontSize: 13, color: '#888', fontFamily: '"DM Sans", sans-serif', lineHeight: 1.6, marginBottom: 4 },
  successIcon: { width: 48, height: 48, borderRadius: '50%', background: '#eaf3de', color: '#1a5c38', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontFamily: '"DM Sans", sans-serif' },
  successTitle: { fontSize: 17, fontWeight: 600, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif', marginBottom: 10 },
};

